/* 
  PWA installation utilities handles the logic for capturing 
  the browser's install prompt and identifying device types.
*/

let deferredPrompt = null;

export const checkInstallability = async (setInstallable) => {
  // Check if already installed
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
    setInstallable(false);
    return;
  }

  // iOS detection
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isIOS) {
    // iOS is always "installable" via manual Add to Home Screen
    setInstallable(true);
    return;
  }

  if ('BeforeInstallPromptEvent' in window || deferredPrompt !== null) {
    setInstallable(true);
  }
};

export const storeDeferredPrompt = (e) => {
  e.preventDefault();
  deferredPrompt = e;
};

export const showInstallPrompt = async () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isIOS) {
    return {
      outcome: 'instruction',
      message: 'To install: Tap the "Share" icon at the bottom of your screen and select "Add to Home Screen".'
    };
  }

  if (!deferredPrompt) {
    return {
      outcome: 'unavailable',
      message: 'Installation is not supported on this browser or the app is already installed.'
    };
  }

  try {
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    const outcome = choiceResult.outcome;
    
    // Clear the prompt so it can't be used again
    deferredPrompt = null;
    
    return { outcome, platform: 'native' };
  } catch (error) {
    console.error('Installation failed:', error);
    return { outcome: 'error', message: 'An error occurred during installation.' };
  }
};

export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered:', registration.scope);
      return true;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
      return false;
    }
  }
  return false;
};